/**
 * Auralis Homepage
 * Scroll fade-in animations + Reviews slider
 */
(function () {
  'use strict';

  /* ---------- Scroll Fade-In ---------- */
  function initFadeAnimations() {
    var elements = document.querySelectorAll('.auralis-fade, .auralis-fade-children');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) { el.classList.add('auralis-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('auralis-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Reviews Slider ---------- */
  function initReviewsSlider() {
    var _container = document.querySelector('.auralis-reviews__track-container');
    if (!_container) return;
    /** @type {HTMLElement} */
    var container = /** @type {HTMLElement} */ (_container);

    var _track = container.querySelector('.auralis-reviews__track');
    if (!_track) return;
    /** @type {HTMLElement} */
    var track = /** @type {HTMLElement} */ (_track);

    var slides = track.querySelectorAll('.auralis-reviews__slide');
    var dots = document.querySelectorAll('.auralis-reviews__dot');
    var prevBtn = document.querySelector('.auralis-reviews__arrow--prev');
    var nextBtn = document.querySelector('.auralis-reviews__arrow--next');
    if (!slides.length) return;

    var currentIndex = 0;
    var startX = 0;
    var currentX = 0;
    var isDragging = false;

    function perView() { return window.innerWidth >= 750 ? 3 : 1; }
    function maxIndex() { return Math.max(0, slides.length - perView()); }

    /** @param {boolean} [animate] */
    function update(animate) {
      var w = 100 / perView();
      var offset = -(currentIndex * w);
      track.style.transition = animate !== false
        ? 'transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)' : 'none';
      track.style.transform = 'translateX(' + offset + '%)';

      var max = maxIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === currentIndex);
        /** @type {HTMLElement} */ (dot).style.display = i <= max ? '' : 'none';
      });
    }

    /** @param {number} i */
    function goTo(i) {
      currentIndex = Math.max(0, Math.min(i, maxIndex()));
      update();
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    /* Touch */
    track.addEventListener('touchstart', /** @param {TouchEvent} e */ function (e) {
      var touch = e.touches[0];
      if (!touch) return;
      isDragging = true;
      startX = touch.clientX;
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', /** @param {TouchEvent} e */ function (e) {
      var touch = e.touches[0];
      if (!isDragging || !touch) return;
      currentX = touch.clientX;
      var diff = currentX - startX;
      var w = 100 / perView();
      var offset = -(currentIndex * w) + (diff / container.offsetWidth) * 100;
      track.style.transform = 'translateX(' + offset + '%)';
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;
      var diff = currentX - startX;
      var threshold = container.offsetWidth * 0.15;
      if (diff < -threshold) goTo(currentIndex + 1);
      else if (diff > threshold) goTo(currentIndex - 1);
      else update();
      startX = 0;
      currentX = 0;
    });

    /* Resize */
    /** @type {ReturnType<typeof setTimeout>|null} */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (currentIndex > maxIndex()) currentIndex = maxIndex();
        update(false);
      }, 150);
    });

    update(false);
  }

  /* ---------- Init ---------- */
  function init() {
    initFadeAnimations();
    initReviewsSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
